// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pg7yhRjb__ProductDescription__skeleton-module__container___Sey0m6bJ6MYmZkeA {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 27.875rem;
    padding: 2.5rem 2.75rem;
}

.pg7yhRjb__ProductDescription__skeleton-module__heading___BA_K0IF1PQpTvKF5 {
    width: 70%;
    height: 1.5rem;
}

.pg7yhRjb__ProductDescription__skeleton-module__bullet___s9DYBtnq498IfPUl {
    width: 80%;
    height: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/modules/productInfo/components/ProductDescription/skeleton.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    width: 27.875rem;\n    padding: 2.5rem 2.75rem;\n}\n\n.heading {\n    width: 70%;\n    height: 1.5rem;\n}\n\n.bullet {\n    width: 80%;\n    height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `pg7yhRjb__ProductDescription__skeleton-module__container___Sey0m6bJ6MYmZkeA`;
export var heading = `pg7yhRjb__ProductDescription__skeleton-module__heading___BA_K0IF1PQpTvKF5`;
export var bullet = `pg7yhRjb__ProductDescription__skeleton-module__bullet___s9DYBtnq498IfPUl`;
export default ___CSS_LOADER_EXPORT___;
